import React from "react";
import styles from "./policy.module.css";
import { getData as getDataLegal } from "./templates/legal_notice";
import { getData as getDataCookiesPolicy } from "./templates/cookies_policy";
import { getData as getDataPrivacityPolicy } from "./templates/privacity_policy";
import { getData as getDataServiceConditions } from "./templates/service_conditions";


export enum PolicyType {
  LEGAL_NOTICE = "LEGAL_NOTICE",
  SERVICE_CONDITIONS = "SERVICE_CONDITIONS",
  COOKIES_POLICY = "COOKIES_POLICY",
  PRIVACITY_POLICY = "PRIVACITY_POLICY"
};

const POLICIES : any = {
    LEGAL_NOTICE : getDataLegal,
    SERVICE_CONDITIONS : getDataServiceConditions,
    COOKIES_POLICY: getDataCookiesPolicy,
    PRIVACITY_POLICY: getDataPrivacityPolicy
}

interface PolicyProps {
  type: PolicyType;
  data?: object;
}



export const Policy = (props: PolicyProps) => {
  const { type, data } = props;
  const getTemplate = POLICIES[type];
  
  return (
    <div 
        className={styles.policy} 
        dangerouslySetInnerHTML={{ 
            __html: getTemplate(data)
        }}
    ></div>
  );
};
